import React from "react";
import ModalSubmit from "components/common/ModalSubmit";
import Modal from "./Modal";
import BootstrapModalWrapper from "./BootstrapModalWrapper";
const BootstrapModalConfirm = ({
  cancelButtonDisabled = false,
  children,
  confirmButtonDisabled = false,
  confirmButtonText = "Confirm",
  isAsyncSubmit = void 0,
  isSubmitting = void 0,
  onCancel,
  onConfirm,
  showModal,
  submitLoadingText = void 0,
  title,
  ...restProps
}) => /* @__PURE__ */ React.createElement(BootstrapModalWrapper, { showModal, onHide: onCancel, ...restProps }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, title)), /* @__PURE__ */ React.createElement(Modal.Body, null, children), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
  ModalSubmit,
  {
    disabledCancel: cancelButtonDisabled,
    disabledSubmit: confirmButtonDisabled,
    isAsyncSubmit,
    submitLoadingText,
    onCancel,
    onSubmit: onConfirm,
    isSubmitting,
    submitButtonText: confirmButtonText,
    submitButtonType: "button"
  }
)));
export default BootstrapModalConfirm;
